import { ICity } from '../../../models/interfaces/iCity'

export default class State {
	public all: ICity[] = [];
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/cities/state.ts